import React from "react"

export const BulkActionsUnsuppress = () => (
    <div className="bulk-actions-console-unsuppress-form" data-cy="bulk-actions-console-unsuppress-form" />
)

export default BulkActionsUnsuppress
